import { render } from "./WizardSteps.vue?vue&type=template&id=3f456284&scoped=true&ts=true"
import script from "./WizardSteps.vue?vue&type=script&lang=ts"
export * from "./WizardSteps.vue?vue&type=script&lang=ts"

import "./WizardSteps.vue?vue&type=style&index=0&id=3f456284&lang=scss&scoped=true"
import "./WizardSteps.vue?vue&type=style&index=1&id=3f456284&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f456284"]])

export default __exports__